// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rBHX-","title":"Header_title__AEqT3"};